import { z } from 'zod';
export const SURVEY_ACTIVITY_KINDS = {
    Created: 'survey.created',
    Updated: 'survey.updated',
    Published: 'survey.published',
    Opened: 'survey.opened',
    Closed: 'survey.closed',
    Archived: 'survey.archived',
    CapReached: 'survey.cap-reached',
    ResponseSubmitted: 'survey.response-submitted',
};
export const SURVEY_ACTIVITY_KIND_GLOB = 'survey.*';
const Iso = z.string().datetime({ offset: true });
export const SurveyLifecycleEvent = z.object({
    type: z.string(),
    surveyId: z.string().uuid(),
    actorId: z.string().uuid(),
    status: z.string(),
    occurredAt: Iso,
});
export const SurveyResponseSubmittedEvent = z.object({
    type: z.literal('survey.response-submitted'),
    surveyId: z.string().uuid(),
    responseId: z.string().uuid(),
    respondentId: z.string().uuid().nullable(),
    responseCount: z.number().int().nonnegative(),
    occurredAt: Iso,
});
export const SurveyCapReachedEvent = z.object({
    type: z.literal('survey.cap-reached'),
    surveyId: z.string().uuid(),
    responseCap: z.number().int().positive(),
    responseCount: z.number().int().nonnegative(),
    occurredAt: Iso,
});
//# sourceMappingURL=events.js.map